import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterBy',
    standalone: false
})
export class FilterByPipe implements PipeTransform {

  transform(list: any[], prop:string = '', propValue: string = ''): any[] {

    if (!list || prop === '' || !prop) { 
      return list;
    }
    if (list.length < 1) {
       return list; 
    }

    return list
          .filter(obj => {
            if(obj.key && obj.value){
              if(propValue === 'Default'){
                return obj.value[prop] === '' || obj.value[prop]  === propValue;
              }else{
                return obj.value[prop]  === propValue;
              }
            }
            return obj[prop]  === propValue;
          });
  }

}
